import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { StyledCol, StyledRow } from './styles'
import { useTranslation } from '../../../context/translationProvider'
import { AuthContext } from '../../../context/authProvider'
import { FormatAmount } from '../formatAmount'

const AmountRange = ({ minimumAmount, maximumAmount }) => {
  const { translate } = useTranslation()
  const { user } = useContext(AuthContext)

  return (
    <StyledRow>
      <StyledCol>
        {translate('payments.minimum')}
        {': '}
        <FormatAmount
          amount={minimumAmount}
          shortCode={user?.wallet?.currency.short_code}
          maximumFractionDigits="0"
          useGrouping={minimumAmount.toString().length >= 5}
          currencySymbol={user?.wallet?.currency?.symbol}
        />
      </StyledCol>
      <StyledCol>
        {translate('payments.maximum')}
        {': '}
        <FormatAmount
          amount={maximumAmount}
          shortCode={user?.wallet?.currency.short_code}
          maximumFractionDigits="0"
          useGrouping={maximumAmount.toString().length >= 5}
          currencySymbol={user?.wallet?.currency?.symbol}
        />
      </StyledCol>
    </StyledRow>
  )
}

AmountRange.propTypes = {
  minimumAmount: PropTypes.number,
  maximumAmount: PropTypes.number,
}

export { AmountRange }
